import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslationService } from '../../../translations';

@Component({
    selector: 'account-billing-check-panel',
    template: `<div class="peek-panel-div">
        <div>
            <div class="title-dashboard">
                {{ TR.key('billing-manager.payment-methods.peek-panel-title') }}
            </div>
            <div class="title-md">
                {{
                    TR.key('billing-manager.payment-methods.check-panel-header')
                }}
            </div>
        </div>
        <br /><br />
        <div class="layoutVertical">
            <span class="subsection-title">
                {{
                    TR.key(
                        'billing-manager.payment-methods.check-definition-title'
                    )
                }}
            </span>
            <br />
            <span class="subsection-details">
                {{
                    TR.key(
                        'billing-manager.payment-methods.check-definition-subtitle'
                    )
                }}
            </span>
            <br /><br />
            <span class="section-title">
                {{
                    TR.key(
                        'billing-manager.payment-methods.check-details-title'
                    )
                }}
            </span>
            <br />
            <span>
                {{ TR.key('billing-manager.payment-methods.check-details') }}
            </span>
            <br />
            <span class="subsection-title">
                {{
                    TR.key(
                        'billing-manager.payment-methods.send-check-instructions'
                    )
                }}
            </span>
            <br />
            <div class="subsection-details layoutVertical">
                <span style="margin-bottom: 8px;">{{
                    TR.key(
                        'billing-manager.billing-payment-details-pi-company-name'
                    )
                }}</span>
                <span
                    [innerHtml]="
                        TR.key('billing-manager.payment-methods.po-box-detroit')
                    "
                >
                </span>
            </div>

            <br />
        </div>
        <div class="peek-panel-footer">
            <div class="layoutHorizontalSpacing ">
                <div>
                    <span>
                        <b>
                            {{
                                TR.key(
                                    'billing-manager.billing-payment-details-peek-panel-questions'
                                )
                            }}
                        </b>
                    </span>
                    <span>
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-peek-panel-contact-instruction'
                            )
                        }}
                    </span>
                    <br />
                    <a class="billing-email" href="mailto:{{ billingHref }}">
                        {{ billingEmail }}
                    </a>
                </div>
                <div class="peek-panel-footer-button-container">
                    <button
                        class="button button-md button-primary"
                        (click)="closeClick()"
                    >
                        {{ TR.key('label.common-terms.close') }}
                    </button>
                </div>
            </div>
            <br />
        </div>
    </div>`,
    styleUrls: ['../account-billing-manager.less'],
    standalone: false
})
export class AccountBillingCheckPanelComponent implements OnInit {
    @Output()
    closePanel = new EventEmitter<boolean>();

    billingHref: string;
    billingEmail: string;

    constructor(public TR: TranslationService) {}

    ngOnInit(): void {
        this.billingEmail = this.TR.key(
            'billing-manager.billing-payment-details-peek-panel-contact-billing-email'
        );
        const billingSubject = this.TR.key(
            'billing-manager.billing-payment-details-peek-panel-contact-billing-email-subject'
        );
        this.billingHref = `${this.billingEmail}?subject=${billingSubject}`;
    }

    closeClick() {
        this.closePanel.emit(false);
    }
}
